document.querySelector("header .toggle-menu").addEventListener("click", () => {
	document.querySelector("header").classList.toggle("menu-open");
});